import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable, of} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {PageLinkFilterLabel} from '../page-link-filter-label';
import {PageLinkModel} from '../page-link.model';

@Component({
  selector: 'app-form-links',
  templateUrl: './form-links.component.html',
  styleUrls: ['./form-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FormLinksComponent implements OnInit, OnChanges {
  @Input() limit = -1;
  @Input() pageLinks: PageLinkModel[] = [];
  @Input() resolve: Params = {};
  @Input() filterLabels: PageLinkFilterLabel[] = [];

  bindFilterLabels = this.filterByLabels.bind(this);

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router) {
  }

  ngOnInit(): void {
    return;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateLinksCount();
  }

  updateLinksCount(): void {
    this.pageLinks.forEach(link => {
      const countSource = link.countUrl;
      if (typeof countSource === 'number') {
        link.count = of(countSource);
        return;
      }

      if (Array.isArray(countSource)) {
        const requests: Observable<number>[] = countSource.map(url =>
          this.http.get<unknown>(this.resolveUrl(url)).pipe(
            map(result => this.getResultCount(result))
          )
        );
        link.count = requests.length > 0
          ? forkJoin(requests).pipe(
            map((counts: number[]) => counts.reduce((total: number, count: number) => total + count, 0)),
            shareReplay({bufferSize: 1, refCount: true})
          )
          : of(0);
        return;
      }

      if (typeof countSource === 'string' && countSource.length > 0) {
        link.count = this.http.get<unknown>(this.resolveUrl(countSource)).pipe(
          map(result => this.getResultCount(result)),
          shareReplay({bufferSize: 1, refCount: true})
        );
      }
    });
  }

  resolveUrl(url: string): string {
    let resolvedUrl = url;
    Object.keys(this.resolve).forEach(key => {
      if (this.resolve[key]) {
        resolvedUrl = resolvedUrl.replace(`:${key}`, this.resolve[key]);
      }
    });
    Object.keys(this.route.snapshot.params).forEach(key => {
      if (this.route.snapshot.params[key]) {
        resolvedUrl = resolvedUrl.replace(`:${key}`, this.route.snapshot.params[key]);
      }
    });
    Object.keys(this.route.parent?.snapshot.params || {}).forEach(key => {
      resolvedUrl = resolvedUrl.replace(`:${key}`, this.route.parent.snapshot.params[key]);
    });
    return resolvedUrl;
  }

  navigateClearRightPanel(link: any): void {
    this.router.navigateByUrl(this.resolveUrl(link.url));
  }

  resolveQueryParams(params: {}): {} {
    if (params) {
      const resolvedparams = {};
      Object.keys(this.resolve).forEach(key => {
        if (this.resolve[key] && params[key]) {
          resolvedparams[params[key]] = this.resolve[key];
        }
      });
      return resolvedparams;
    }
  }

  filterByLabels(data): boolean {
    return (this.filterLabels.find(filter => filter.label === data.label) || {label: 'any', isShow: true}).isShow;
  }

  private getResultCount(result: unknown): number {
    if (typeof result === 'number') {
      return result;
    }
    if (Array.isArray(result)) {
      return result.length;
    }
    return 0;
  }
}
